import CryptoJS from 'crypto-js';

export const ECON = 'econ';
export const UCTN = 'uctn';
export const USER_KEY = '7473c2977f8181b2';
export const USER_IV = 'cc5a71f609dc05e4';

export enum GlobalStateEnum {
    SITE = 'site',
    LANG = 'lang',
    ONLINE = 'onLine',
    TOKEN = 'token',
    VERSION = 'version',
    CODE = 'code',
    ACCOUNT = 'account',
    DID = 'did', // 设备id 手机唯一标识
    APPID = 'x-appid', // App渠道标志
}

export const getLocalStorage: any = (key: string) => {
    try {
        return localStorage.getItem(key);
    } catch (e) {
        console.error(e);
    }
};

export const getAesEncryptValData = (value: string, keyStr: string, ivStr: string): string => {
    if (!value) return '';
    try {
        const encrypted = CryptoJS.enc.Base64.parse(value);
        const key = CryptoJS.enc.Utf8.parse(keyStr);
        const iv = CryptoJS.enc.Utf8.parse(ivStr);
        // @ts-ignore
        const decrypted = CryptoJS.AES.decrypt({ ciphertext: encrypted }, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        let token = decrypted.toString(CryptoJS.enc.Utf8);
        if (token && token.startsWith('Bearer ')) {
            token = token.replace('Bearer ', '');
        }
        return token;
    } catch {
        return '';
    }
};

export const getAppSession = () => getAesEncryptValData(getLocalStorage(ECON), USER_KEY, USER_IV) || getLocalStorage(GlobalStateEnum.TOKEN);
